import _ from "lodash";

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'email' implicitly has an 'any' type.
export const nameFromEmail = (email, includeClipboard = false) => {
  if (_.isEmpty(email)) {
    return "";
  }

  const [name] = email.split("@");
  return `${_.capitalize(name)} ${includeClipboard ? "Clipboard" : ""}`;
};

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'name' implicitly has an 'any' type.
export const fullNameToFirstLast = (name) => {
  const nameArray = _.split(name, " ");
  const firstName = _.dropRight(nameArray).join(" ");
  const lastName = _.last(nameArray);

  return { firstName, lastName };
};
